import React, { useState } from "react";
import useSWR from "swr";
import { fetcher } from "../../../components/Overview/Overview";
import { CompetenceRow, EndTermRow, KnowledgeExamResultRow } from "../../students/courses";

export const EndTermRowExtended = ({ endTerm, allCompetences, courseDetails }) => {
    const [open, setOpen] = useState(false);

    const rows = [
        <EndTermRow forceIndent={0} statusFlip={true} key={endTerm.uuid} endTerm={endTerm} course={courseDetails} open={open} onClick={() => setOpen(!open)} />
    ];

    const competenceRows = open
        ? endTerm.competences.map((competence) => {
            return (
                <CompetenceRow
                    allCompetences={allCompetences}
                    forceIndent={1}
                    statusFlip={true}
                    endTerm={endTerm}
                    competence={competence}
                    course={courseDetails}
                    key={endTerm.uuid + "-" + competence.uuid}
                />
            );
        })
        : [];

    return [...rows, ...competenceRows];
};

export default function TabledEventStudent({ ignoreProgressFromOtherCourses, studentUUID, courseUUID }) {
    const { data: courseDetails } = useSWR(() => (studentUUID && courseUUID ? `/v1/users/${studentUUID}/courses/${courseUUID}/` : false), fetcher);
    const { data: allCompetences } = useSWR(
        () => (studentUUID && courseUUID ? `/v1/courses/${courseUUID}/students/${studentUUID}/results/?measurement_type=practice` : false),
        fetcher
    );
    const { data: studentDetails } = useSWR(() => (courseUUID ? `/v1/courses/${courseUUID}/students/?limit=10000` : false), fetcher);

    const student = studentDetails?.results?.find((s) => s.uuid === studentUUID);

    const endTerms = courseDetails?.competence_profile?.end_terms;

    if (!endTerms) return null;

    return (
        <table className={"table table-hover"}>
            <thead>
                <tr>
                    <th colSpan={3}>Onderdeel</th>
                    <th className={"course-status-table__expiration"}>Geldig tot</th>
                    <th className={"course-status-table__score"}>Score</th>
                    <th className={"course-status-table__status"}>Status</th>
                </tr>
            </thead>
            <tbody>
                {endTerms.map((endTerm) => {
                    const allEndTerms = [];

                    student.available_certifications.forEach((certification) => {
                        certification.end_terms.forEach((e) => {
                            if (e.uuid === endTerm.uuid) allEndTerms.push(e);
                        });
                    });

                    const highestScoredEndTerms = allEndTerms.filter(
                        (e) =>
                            e.latest_progress?.is_achieved &&
                            e.latest_progress?.status_slug === "achieved" &&
                            Math.floor((new Date() - new Date(e.latest_progress?.date)) / (1000 * 60 * 60 * 24)) <= 93
                    );

                    const sortedAchievedTerms = highestScoredEndTerms.sort((a, b) => {
                        const dateA = new Date(a.latest_progress?.date);
                        const dateB = new Date(b.latest_progress?.date);
                        return dateB - dateA;
                    });

                    const highestScored = sortedAchievedTerms[0];

                    return (
                        <EndTermRowExtended
                            key={endTerm.uuid}
                            allCompetences={allCompetences?.results || []}
                            endTerm={ignoreProgressFromOtherCourses ? endTerm : highestScored ? { ...highestScored, competences: [] } : endTerm}
                            courseDetails={courseDetails}
                        />
                    );
                })}
            </tbody>
        </table>
    );
}
